import React from 'react';

export default function ChildAvatarLogo({value, height, width}) {
    const avatar = value.photo?.link;

    return (
        <>
            {avatar ?
                <img src={avatar} alt="" className="rounded-circle" height={height} width={width}/>
                :
                <div className="avatar-xs avatar-placeholder m-0">
                    <span className="avatar-title rounded-circle">
                        {value.firstName ? value.firstName.charAt(0).toUpperCase() : "-"}
                    </span>
                </div>

            }
        </>
    )
}
